import * as contentful from 'contentful'

export const client = contentful.createClient({
    space: 'e16kkd4dabkb',
    accessToken: '3vd49qtPBZsEECsd3tSfld2VQuu3_4IRT-tR7Hmb2dA'
})